<div class="modal-footer {{class}}">
  <ng-content></ng-content>
</div>
